module.exports = __webpack_public_path__ + "static/media/car-qr-code-error.08a3aa6b.svg";